import styled from 'styled-components'
import Text from 'components/priority/Text/Text'

export const SpacedText = styled(Text)`
  margin-bottom: 20px;
`
